import styled from "styled-components";

interface StyledRightSidePositionProps {
  marginLeft?: string;
  minHeight?: string;
}

export const StyledRightSidePosition = styled.div<StyledRightSidePositionProps>`
  min-height: ${({ minHeight }) => minHeight};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
`;
